import { CurriculumRow } from '../CurriculumRow';

interface CurriculumHeaderProps {
  rows: any[];
}

export const CurriculumHeader = ({ rows }: CurriculumHeaderProps) => {
  return (
    <thead>
      {rows.map((row: any, index: number) => {
        return (
          <CurriculumRow isFirstRow={index === 0} key={`${row.id}-${index}`} Tag="th" row={row} />
        );
      })}
    </thead>
  );
};
